// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import CityPopupModal from "./CityPopupModal";
// import AddNew from "./AddNewButton";
// import { Box, TextField, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Divider } from "@mui/material";

// // const path = "http://103.251.218.254:91/api";


// const CitySearchInput = ({ value, onSelectCity, disabled = false, label = "City", cities, onNoResults, connectionString }) => {
//   const path = connectionString;
//   const [query, setQuery] = useState(value || "");
//   const [results, setResults] = useState([]);
//   const [showCityModal, setShowCityModal] = useState(false);
//   const [showResults, setShowResults] = useState(false);
//   const [isSelecting, setIsSelecting] = useState(false); // New flag to track selection
//   const inputRef = useRef(null);
//   const blurTimeoutRef = useRef(null); // Ref to store blur timeout

//   useEffect(() => {
//     if (disabled || query.trim() === "") {
//       setResults([]);
//       setShowResults(false);
//       return;
//     }

//     const fetchCities = async () => {
//       try {
//         const res = await axios.get(`${path}/api/get-cities`, { params: { query } });
//         const fetched = res.data.cities || [];
//         setResults(fetched);
//         setShowResults(fetched.length > 0);
//         if (fetched.length === 0 && onNoResults) onNoResults();
//       } catch (error) {
//         console.error("Error fetching cities:", error);
//       }
//     };

//     fetchCities();
//   }, [query, disabled, onNoResults]);

//   useEffect(() => {
//     setQuery(value || "");
//   }, [value]);

//   const handleChange = (e) => {
//     setQuery(e.target.value);
//     setShowResults(true); // Show results when typing
//   };

//   const handleSelect = (cityObj) => {
//     setIsSelecting(true); // Indicate selection is in progress
//     setQuery(cityObj.city);
//     setResults([]);
//     setShowResults(false);
//     onSelectCity?.(cityObj);
//     // Delay resetting isSelecting to ensure blur doesn't interfere
//     setTimeout(() => {
//       setIsSelecting(false);
//       inputRef.current?.blur(); // Programmatically blur the input after selection
//     }, 100);
//   };

//   const handleBlur = () => {
//     // Only close dropdown if not selecting
//     if (!isSelecting) {
//       // Delay closing to allow click to register
//       blurTimeoutRef.current = setTimeout(() => {
//         setShowResults(false);
//         setResults([]);
//       }, 200);
//     }
//   };

//   const handleFocus = () => {
//     // Clear any pending blur timeout
//     if (blurTimeoutRef.current) {
//       clearTimeout(blurTimeoutRef.current);
//     }
//     if (!disabled && query.trim()) {
//       setShowResults(true); // Show results on focus if query exists
//     }
//   };

//   const handleCityAdded = (newCity) => {
//     setResults((prev) => [newCity, ...prev]);
//     setQuery(newCity.city);
//     setShowResults(false);
//     onSelectCity?.(newCity);
//     setShowCityModal(false);
//   };

//   const openAddNewViaPointer = () => {
//     setShowCityModal(true);
//     setShowResults(false); // Close dropdown when opening modal
//   };

//   // Cleanup timeout on unmount
//   useEffect(() => {
//     return () => {
//       if (blurTimeoutRef.current) {
//         clearTimeout(blurTimeoutRef.current);
//       }
//     };
//   }, []);

//   return (
//     <Box sx={{ position: "relative", width: "100%" }}>
//       {/* Search Input */}
//       <TextField
//         id="city-search"
//         required
//         label={label}
//         value={query}
//         onChange={handleChange}
//         disabled={disabled}
//         onFocus={handleFocus}
//         onBlur={handleBlur}
//         fullWidth
//         variant="outlined"
//         size="small"
//         inputRef={inputRef}
//         sx={{
//           "& .MuiOutlinedInput-root": {
//             borderRadius: 1,
//             backgroundColor: "#fff",
//           },
//         }}
//       />

//       {/* Search Results Dropdown */}
//       {!disabled && showResults && (
//         <Box
//           sx={{
//             position: "absolute",
//             zIndex: 10,
//             width: "200%",
//             mt: 1,
//             borderRadius: 2,
//             border: "1px solid",
//             borderColor: "divider",
//             boxShadow: 3,
//             overflow: "hidden",
//             maxHeight: 320,
//             backgroundColor: "background.paper",
//           }}
//         >
//           {/* 📱 Mobile View */}
//           <Box
//             sx={{
//               display: { xs: "flex", sm: "none" },
//               flexDirection: "column",
//               gap: 1,
//               p: 1,
//               overflowY: "auto",
//               maxHeight: 240,
//             }}
//           >
//             {results.map((cityObj, index) => (
//               <Box
//                 key={index}
//                 onClick={() => handleSelect(cityObj)} // Changed to onClick
//                 sx={{
//                   p: 1,
//                   border: "1px solid",
//                   borderColor: "divider",
//                   borderRadius: 1,
//                   cursor: "pointer",
//                   transition: "background 0.2s",
//                   "&:hover": { backgroundColor: "grey.100" },
//                 }}
//               >
//                 {/* Top row */}
//                 <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ minHeight: 32 }}>
//                   <Typography variant="body1" fontWeight={600}>
//                     {cityObj.city}
//                   </Typography>
//                   <Box sx={{ px: 1.5, py: 0.5, display: "flex", alignItems: "center", minHeight: 24 }}>
//                     <Typography variant="body2" fontWeight={500} color="text.secondary" sx={{ lineHeight: 1.5 }}>
//                       {cityObj.country || "—"}
//                     </Typography>
//                   </Box>
//                 </Box>
//                 {/* Bottom row */}
//                 <Typography variant="body2" color="text.secondary">
//                   {cityObj.state}
//                   {cityObj.stateCode ? ` | ${cityObj.stateCode}` : ""}
//                 </Typography>
//               </Box>
//             ))}
//           </Box>

//           {/* 🖥️ Desktop View */}
//           <TableContainer
//             sx={{
//               maxHeight: 240,
//               overflowY: "auto",
//               width: "106%",
//               display: { xs: "none", sm: "block" },
//             }}
//           >
//             <Table size="small" stickyHeader>
//               <TableHead>
//                 <TableRow>
//                   {["City", "State", "Country"].map((header, i) => (
//                     <TableCell
//                       key={i}
//                       sx={{
//                         fontWeight: 500,
//                         fontSize: "0.75rem",
//                         color: "text.secondary",
//                         backgroundColor: "grey.100",
//                         width: i === 0 ? "40%" : "30%",
//                       }}
//                     >
//                       {header}
//                     </TableCell>
//                   ))}
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {results.map((cityObj, index) => (
//                   <TableRow
//                     key={index}
//                     hover
//                     onClick={() => handleSelect(cityObj)} // Changed to onClick
//                     sx={{
//                       cursor: "pointer",
//                       transition: "background 0.2s",
//                       "&:hover": { backgroundColor: "grey.100" },
//                     }}
//                   >
//                     <TableCell sx={{ py: 1 }}>
//                       <Typography variant="body1" fontWeight={600}>
//                         {cityObj.city}
//                       </Typography>
//                     </TableCell>
//                     <TableCell sx={{ py: 1 }}>
//                       <Typography variant="body2" color="text.secondary">
//                         {cityObj.state}
//                         {cityObj.stateCode ? ` | ${cityObj.stateCode}` : ""}
//                       </Typography>
//                     </TableCell>
//                     <TableCell sx={{ py: 1 }}>
//                       <Typography variant="body2" color="text.secondary">
//                         {cityObj.country || "—"}
//                       </Typography>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>

//           {/* ➕ Add New Button Section */}
//           <Divider sx={{ mt: 1 }} />
//           <Box
//             sx={{ mt: 3.5, p: 1.5, backgroundColor: "background.paper" }}
//             onClick={openAddNewViaPointer}
//           >
//             <AddNew />
//           </Box>
//         </Box>
//       )}

//       {/* Modal to Add New City */}
//       {showCityModal && (
//         <CityPopupModal
//           onClose={() => setShowCityModal(false)}
//           onCityAdded={handleCityAdded}
//           connectionString={connectionString}
//         />
//       )}
//     </Box>
//   );
// };

// export default CitySearchInput;



import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import CityPopupModal from "./CityPopupModal";
import AddNew from "./AddNewButton";
import { Box, TextField, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography, Divider } from "@mui/material";
import { toProperCase } from "../utils/formatRows";

// Create a fresh axios instance without auth interceptors for external APIs
const axiosNoAuth = axios.create();

const CitySearchInput = ({ value, onSelectCity, disabled = false, label = "City", cities, onNoResults, connectionString, forceShowDropdown = false, showWarning = false, validationStatus = null , error, required = true,}) => {
  const path = connectionString;
  const [query, setQuery] = useState(value || "");
  const [results, setResults] = useState([]);
  const [showCityModal, setShowCityModal] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [isSelecting, setIsSelecting] = useState(false); // New flag to track selection
  const [isTyping, setIsTyping] = useState(false);

  const inputRef = useRef(null);
  const blurTimeoutRef = useRef(null); // Ref to store blur timeout

  useEffect(() => {
    if (disabled || query.trim() === "") {
      setResults([]);
      setShowResults(false);
      return;
    }

    const fetchCities = async () => {
      try {
        const res = await axios.get(`${path}/api/get-cities`, { params: { query } });
        const fetched = res.data.cities || [];
        setResults(fetched);
        setShowResults(fetched.length > 0);
        if (fetched.length === 0 && onNoResults) onNoResults();
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchCities();
  }, [query, disabled, onNoResults]);

  useEffect(() => {
    setQuery(value || "");
  }, [value]);

  const handleChange = (e) => {
    setQuery(toProperCase(e.target.value));
    setIsTyping(true);      // 👈 mark user is typing
    setShowResults(true);
  };

  const handleSelect = (cityObj) => {
    console.log(cityObj)
    setIsSelecting(true);
    setIsTyping(false);     // 👈 stop typing
    setQuery(cityObj.city);
    setResults([]);
    setShowResults(false);
    onSelectCity?.(cityObj);

    setTimeout(() => {
      setIsSelecting(false);
      inputRef.current?.blur();
    }, 100);
  };

  const handleBlur = () => {
    if (!isSelecting) {
      setIsTyping(false);   // 👈 stop typing
      blurTimeoutRef.current = setTimeout(() => {
        setShowResults(false);
        setResults([]);
      }, 200);
    }
  };

  // const handleBlur = () => {
  //   // Only close dropdown if not selecting
  //   if (!isSelecting) {
  //     // Delay closing to allow click to register
  //     blurTimeoutRef.current = setTimeout(() => {
  //       setShowResults(false);
  //       setResults([]);
  //     }, 200);
  //   }
  // };

  const handleFocus = () => {
    if (blurTimeoutRef.current) {
      clearTimeout(blurTimeoutRef.current);
    }
    // ❌ do nothing else
  };

  const handleCityAdded = (newCity) => {
    setResults((prev) => [newCity, ...prev]);
    setQuery(newCity.city);
    setShowResults(false);
    onSelectCity?.(newCity);
    setShowCityModal(false);
  };

  const openAddNewViaPointer = () => {
    setShowCityModal(true);
    setShowResults(false); // Close dropdown when opening modal
  };

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (blurTimeoutRef.current) {
        clearTimeout(blurTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      {/* Search Input */}
      <TextField id="city-search" label={label} value={toProperCase(query)} onChange={handleChange} disabled={disabled} required={required} onFocus={handleFocus} onBlur={handleBlur} fullWidth variant="outlined" size="small" inputRef={inputRef}
       InputLabelProps={{
            sx: {
                '& .MuiFormLabel-asterisk': {
                    color: 'red',
                },
            },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 1,
            height: 38,
            backgroundColor: showWarning ? "#fff3cd" : "#fff",  // ← ADD THIS LINE
            borderColor: showWarning ? "#ffc107" : "inherit",   // ← ADD THIS LINE
          },
        }}
         error={error} 
      />

      {/* Search Results Dropdown */}
      {!disabled && (isTyping || forceShowDropdown) && query.trim() !== "" && (
        <Box sx={{ position: "absolute", zIndex: 10, width: "100%", mt: 1, borderRadius: 2, border: "1px solid", borderColor: "divider", boxShadow: 3, backgroundColor: "background.paper", overflow: "hidden", display: "flex", flexDirection: "column", }} >
          {/* Section Header */}
          <Typography variant="caption" sx={{ px: 2, py: 1, fontWeight: 600, color: "text.secondary", textTransform: "uppercase", letterSpacing: 0.5, backgroundColor: "background.paper", }} >
            Cities
          </Typography>

          {showWarning && validationStatus?.missingCityState && (
            <Box sx={{ px: 2, py: 1.5, backgroundColor: "#fff3cd", borderBottom: "1px solid #ffc107" }}>
              <Typography variant="caption" sx={{ color: "#856404", fontWeight: 500 }}>
                ⚠️ {validationStatus.message}
              </Typography>
            </Box>
          )}

          {/* Results List (Scrollable Only) */}
          <Box sx={{ maxHeight: 220, overflowY: "auto", }} >
            {results.map((cityObj, index) => (
              <Box key={index}
                onMouseDown={(e) => {
                  e.preventDefault();   // stops blur
                  handleSelect(cityObj);
                }}
                sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2, py: 0.5, cursor: "pointer", borderBottom: "1px solid", borderColor: "divider", "&:last-child": { borderBottom: "none" }, transition: "background 0.2s", "&:hover": { backgroundColor: "grey.100", }, }}
              >
                {/* Left Content */}
                <Box>
                  <Typography variant="body1" fontWeight={600}>
                    {toProperCase(cityObj.city)}
                  </Typography>

                  <Typography variant="body2" color="text.secondary" sx={{ fontSize: "0.8rem" }} >
                    {toProperCase(cityObj.state)}, {toProperCase(cityObj.country)}
                  </Typography>
                </Box>

                {/* Right Side State Code */}
                <Typography variant="body2" sx={{ fontWeight: 600, color: "text.secondary", minWidth: 40, textAlign: "right", }} >
                  {toProperCase(cityObj.stateCode) || ""}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* ➕ Add New Button – FIXED BOTTOM SECTION */}
          <Divider sx={{ mt: 1 }} />
          <Box
            sx={{ mt: 3.5, p: 1.5, backgroundColor: "background.paper" }}
            onMouseDown={(e) => {
              e.preventDefault();   // ⬅️ prevents TextField blur
              openAddNewViaPointer();
            }}
          >
            <AddNew />
          </Box>

        </Box>
      )}

      {/* Modal to Add New City */}
      {showCityModal && (
        <CityPopupModal
          onClose={() => setShowCityModal(false)}
          onCityAdded={(newCity) => {
            setQuery(newCity.city);
            setShowResults(false);
            onSelectCity?.(newCity);
             setShowCityModal(false)
          }}
          connectionString={connectionString}
        />
      )}
    </Box>
  );
};

export default CitySearchInput;